/**
 * Updates a Partial View.
 * @param {string} idDiv - ID of the div containing the partial view.
 * @param {string} controller - Controller name.
 * @param {string} action - Action name.
 * @param {string} [param=""] - Parameters (e.g., "/id" or "?param=value").
 * @param {string} [messageError="Errore: "] - Error message to display.
 */
export function InCoreReloadPartial(
    idDiv: string,
    controller: string,
    action: string,
    param: string = "",
    messageError: string = "Errore: "
): void {
    $.ajax({
        url: `/${controller}/${action}${param}`,
        type: "GET",
        dataType: "html",
        cache: false,
        success: function (html) {
            $(`#${idDiv}`).html(html);
        },
        error: function (_xhr, _status, error) {
            console.error(messageError, error);
        }
    });
}

/**
 * Updates a Partial View.
 * @param {string} idDiv - ID of the div containing the partial view.
 * @param {string} controller - Controller name.
 * @param {string} action - Action name.
 * @param {string} [param=""] - Parameters (e.g., "/id" or "?param=value").
 * @param {string} [messageError="Errore: "] - Error message to display.
 */
export async function InCoreReloadPartialAsync(
    idDiv: string,
    controller: string,
    action: string,
    param: string = "",
    messageError: string = "Errore: "
): Promise<void> {

    return new Promise((resolve, reject) => {
        $.ajax({
            url: `/${controller}/${action}${param}`,
            type: "GET",
            dataType: "html",
            cache: false,
            success: function (html) {
                $(`#${idDiv}`).html(html);
                resolve();
            },
            error: function (_xhr, _status, error) {
                console.error(messageError, error);
                reject(error);
            }
        });
    });
}


/**
 * Updates the content of multiple divs.
 * @param {string} idDivs - IDs of the divs to reload, separated by '|'.
 * @param {string} controller - Controller name.
 * @param {string} action - Action name.
 * @param {string} [param=""] - Parameters (e.g., "/id" or "?param=value").
 */
export function InCoreReloadDivs(
    idDivs: string,
    controller: string,
    action: string,
    param: string = ""
): void {
    $.ajax({
        url: `/${controller}/${action}${param}`,
        type: "GET",
        dataType: "html",
        cache: false,
        success: function (html) {
            const divIds = idDivs.split('|');
            $(divIds).each(function (_index, element) {
                const elementHTML = $(html).find(`#${element}`).html();
                $(`#${element}`).html(elementHTML);
            });
        },
        error: function (xhr, status, error) {
            console.error(`Error reloading divs: ${status} - ${error}`);
        }
    });
}

/**
 * Performs an AJAX redirect.
 * @param {string} method - HTTP method (e.g., "GET", "POST").
 * @param {string} url - URL to send the request to.
 * @param {any} [data=null] - Data to send with the request.
 */
export function InCoreAjaxRedirect(method: string, url: string, data: any = null): void {
    $.ajax({
        url: url,
        method: method,
        data: data
    })
        .then(function (response) {
            // Redirect on success
            window.location.href = response.redirectToUrl;
        })
        .catch(function (error) {
            console.error("Error during AJAX call:", error);
        });
}